__turbopack_context__.v({
  "actionsRow": "AssetItemDetail-module__4Y2AJW__actionsRow",
  "folderRestrictionBadge": "AssetItemDetail-module__4Y2AJW__folderRestrictionBadge",
  "folderThumb": "AssetItemDetail-module__4Y2AJW__folderThumb",
  "nonShrinking": "AssetItemDetail-module__4Y2AJW__nonShrinking",
  "subtitleItem": "AssetItemDetail-module__4Y2AJW__subtitleItem",
  "subtitleItems": "AssetItemDetail-module__4Y2AJW__subtitleItems",
  "titleBox": "AssetItemDetail-module__4Y2AJW__titleBox",
  "titleMetaRow": "AssetItemDetail-module__4Y2AJW__titleMetaRow",
});
